var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-card", { staticClass: "pa-5" }, [
    _c(
      "div",
      {
        staticClass: "text-overline grey--text text--darken-2",
        staticStyle: { "line-height": "1.4" },
      },
      [_vm._v("Vista previa")]
    ),
    _c("div", { staticClass: "text-caption grey--text text--darken-1 mb-3" }, [
      _vm._v("Así se verá en el organigrama"),
    ]),
    _c(
      "div",
      { staticClass: "oc-preview" },
      [
        _vm.parent
          ? [
              _c(
                "div",
                {
                  staticClass: "oc-node",
                  class: _vm.nodeClasses(_vm.parent),
                  staticStyle: { height: "48px" },
                },
                [
                  _c("div", { staticClass: "oc-node-text text-center w-100" }, [
                    _c("div", { staticClass: "oc-node-name" }, [
                      _vm._v(_vm._s(_vm.parent.name)),
                    ]),
                  ]),
                ]
              ),
              _c("div", { staticClass: "oc-preview-parent-line" }),
            ]
          : _vm._e(),
        _c("div", { staticClass: "oc-subtree" }, [
          _c(
            "div",
            {
              staticClass: "oc-node oc-node--selected",
              class: _vm.nodeClasses(_vm.item),
            },
            [
              _vm.item.legajo
                ? _c("div", { staticClass: "oc-avatar" }, [
                    _vm._v(_vm._s(_vm.initials(_vm.item.legajo))),
                  ])
                : _c("div", { staticClass: "oc-avatar oc-avatar--vacant" }, [
                    _vm._v("+"),
                  ]),
              _c("div", { staticClass: "oc-node-text" }, [
                _c("div", { staticClass: "oc-node-name" }, [
                  _vm._v(_vm._s(_vm.item.name || "Nuevo puesto")),
                ]),
                _vm.item.legajo
                  ? _c("div", { staticClass: "oc-node-detail" }, [
                      _vm._v(
                        _vm._s(_vm.item.legajo.name) +
                          " " +
                          _vm._s(_vm.item.legajo.surname)
                      ),
                    ])
                  : _c(
                      "div",
                      { staticClass: "oc-node-detail oc-vacant-label" },
                      [_vm._v("Vacante")]
                    ),
              ]),
            ]
          ),
          _vm.children.length > 0
            ? _c(
                "div",
                { staticClass: "oc-children-v" },
                _vm._l(_vm.children, function (child) {
                  return _c(
                    "div",
                    { key: child.id, staticClass: "oc-branch" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "oc-node",
                          class: _vm.nodeClasses(child),
                        },
                        [
                          _c("div", { staticClass: "oc-node-text" }, [
                            _c("div", { staticClass: "oc-node-name" }, [
                              _vm._v(_vm._s(child.name)),
                            ]),
                            child.legajo
                              ? _c("div", { staticClass: "oc-node-detail" }, [
                                  _vm._v(
                                    _vm._s(child.legajo.name) +
                                      " " +
                                      _vm._s(child.legajo.surname)
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "oc-node-detail oc-vacant-label",
                                  },
                                  [_vm._v("Vacante")]
                                ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ],
      2
    ),
    _c(
      "p",
      { staticClass: "text-caption grey--text text--darken-1 mt-6 mb-0" },
      [
        _vm._v(
          "Al cambiar «Depende de», el puesto se mueve junto con todos sus dependientes."
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }